<template>
  <div class="custom-tree-node">
    <div class="tree-name" :id="`${data._id}_navtree_nodeid`" v-context-menu="{ params: params, data: treeMenu }" @click.stop="currNodeChange">
      <span>
        <template v-if="!$navTreeCtrl.icons">
          <i v-if="
               data[$navTreeCtrl.defaultProps.children] !== undefined &&  $navTreeCtrl.showIcon
             "
             class="iconfont"
             :class="[node.expanded ? 'icon-dakai' : 'icon-wenjianjia']" />
          <i v-else-if="$navTreeCtrl.showIcon" class="iconfont icon-shiyongwendang" />
          <slot name="nodeLabel" :data="data">
            <span v-html="dsf.safe.xss(data[$navTreeCtrl.defaultProps.label])"></span>
          </slot>
        </template>
        <template v-else>
          <i v-for="(icon, iconI) in $navTreeCtrl.icons.filter((icon) => {
               return getIconClass(icon, node)[0] != '';
             })"
             :key="iconI"
             class="iconfont"
             :class="getIconClass(icon, node)"
             :style="{ color: icon.color }"></i>
        </template>
        <slot name="nodeLabel" :data="data">
          <span v-html="dsf.safe.xss(data[$navTreeCtrl.defaultProps.label])"></span>
        </slot>
      </span>
      <DsfButtonBar class="ds-no-padding edit-span" :render-button="$navTreeCtrl.renderRowButton" :max-number="$navTreeCtrl.rowButtonsMaxNumber" :more-button-text="$navTreeCtrl.rowButtonsMoreText" :more-button-style="$navTreeCtrl.rowButtonsMoreStyle" :buttons="buttons" v-if="buttons.length>0" :emit-prefix="'row-button'" :local="data" size="small" align="center">
      </DsfButtonBar>
    </div>
  </div>
</template>

<script>
export default {
  name: "navTreeNode",
  inject: {
    $navTreeCtrl: {
      default: null
    }
  },
  props: {
    node: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    this.menuButtonBar = null;
    return {
      data: {},
      treeMenu: this.getMenuButtons(),
      treeClickNum: 0,
      treeClickTemp: null,
      params: {},
      buttons: []
    };
  },
  created() {
    this.data = this.node.data;
    this.params = { $vm: this.$navTreeCtrl, ...this.node };
  },
  methods: {
    currNodeChange() {
      this.treeClickNum++;
      let vm = this;
      vm.treeClickTemp = window.setTimeout(function () {
        vm.$navTreeCtrl.currNodeChange(vm.node.data, vm.node);
        vm.$navTreeCtrl.$refs.tree.setCurrentKey(vm.node.key);
        if (vm.treeClickNum >= 2 && vm.$navTreeCtrl.dblclickIsOpen) {
          if (vm.node.expanded) {
            vm.node.expanded = false;
          } else {
            vm.node.expand();
          }
          window.getSelection ? window.getSelection().removeAllRanges() : document.getSelection.empty();
        }
        vm.treeClickNum = 0;
        clearTimeout(vm.treeClickTemp);
      }, 300);
    },
    getIconClass(iconData, nodeData) {
      if (dsf.express.eval(iconData.code, nodeData.data)) {
        if (nodeData.expanded) {
          return [iconData.iconExpand || ""];
        } else {
          return [iconData.iconFold || ""];
        }
      }
      return [""];
    },
    getMenuButtons() {
      let inject = {};
      ["$app", "$vm", "$page", "$form", "$dialog"].forEach((it) => {
        inject[it] = {
          default: this.$navTreeCtrl[it]
        };
      });
      let menusButtonsProp = this.$navTreeCtrl.menusButtons;
      let DsfButtonBar = Vue.extend({
        mixins: [window.$components["platform"]["DsfButtonBar"]],
        inject
      });
      let btnBarCtrl = (this.menuButtonBar = new DsfButtonBar({
        propsData: {
          isDesign: false,
          owner: this,
          local: this.node.data
        }
      }));

      if (menusButtonsProp?.length > 0) {
        let menusButtonsReal = [];
        _.forEach(menusButtonsProp, (btn) => {
          let btnParams = [];
          if (btn.isUpload) {
            btnParams = this.getButtonParams(btn);
          }
          let uploadState = false;
          if (btn.isUpload) {
            uploadState = {
              action: dsf.url.getWebPath(btnParams[0]),
              data: btnParams[1],
              accept: btnParams[2]
                ?.split("|")
                .map((el) => {
                  el = el.toLowerCase();
                  return dsf.mime[el] || el;
                })
                .join(",")
            };
          }
          menusButtonsReal.push({
            icon: "icon-" + btn.icon,
            name: btn.text || btn.caption,
            upload: uploadState,
            hide: (res) => {
              // let btnBarCtrl = res?.el?.lastElementChild?.__vue__;
              if (btnBarCtrl) {
                return !btnBarCtrl.showAndHide(btn);
              } else {
                return true;
              }
            },
            disabled: (res) => {
              // let btnBarCtrl = res?.el?.lastElementChild?.__vue__;
              if (btnBarCtrl) {
                btnBarCtrl.disabledFactor(btn);
                return btn.disabled;
              } else {
                return true;
              }
            },
            handler: (res) => {
              // res?.el?.lastElementChild?.__vue__?.clickHandler(btn, res.el, res.response?.data);
              btnBarCtrl.clickHandler(btn, res.el, res.response?.data);
            }
          });
        });
        return menusButtonsReal;
      }
    },
    getButtonParams(button) {
      let owner = this.$navTreeCtrl.owner || this.$navTreeCtrl;
      let params = _.map(button.params, (p) => {
        let paramValue = null;
        if (dsf.type(p.value) == "string") {
          let v = p.value.trim();
          if (this.isFunctionCode(v)) {
            paramValue = this.execFunction(button, owner, v);
          } else {
            paramValue = v;
          }
        } else if (dsf.type(p.value) == "object") {
          if (p.value.type == "static") {
            let v = p.value.code || "";
            paramValue = v;
          } else if (p.value.type == "switch") {
            let v = this.local[p.value.code.field] || "";
            paramValue = v;
          } else {
            let v = p.value.code;
            if (this.isFunctionCode(v)) {
              paramValue = this.execFunction(button, owner, v);
            }
          }
        }
        if (paramValue == "" || dsf.isUnDef(paramValue)) {
          paramValue = p.default || null;
        }
        if (paramValue === "false") {
          paramValue = false;
        } else if (paramValue === "true") {
          paramValue = true;
        }
        return paramValue;
      });
      return params;
    },
    getRowButtons(buttons) {
      return dsf.mix(true, [], buttons || []);
    }
  },
  beforeDestroy() {
    this.treeClickTemp && clearTimeout(this.treeClickTemp);
    this.menuButtonBar && this.menuButtonBar.$destroy();
  },
  watch: {
    "$navTreeCtrl.rowButtons": {
      handler(v, ov) {
        this.buttons = this.getRowButtons(this.$navTreeCtrl.rowButtons);
      },
      immediate: true
    }
  }
};
</script>
